<script>
  import ColorSchemesPlugin from 'chartjs-plugin-colorschemes'
  import { Doughnut } from 'vue-chartjs'
  import { merge } from 'lodash'

  const defaultOptions = {
    maintainAspectRatio: false,
    plugins: {
      colorschemes: {
        scheme: 'tableau.MillerStone11'
      }
    }
  }

  export default {
    name: 'Donut',
    extends: Doughnut,
    props: {
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    watch: {
      chartdata () {
        this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
      }
    },
    mounted () {
      this.addPlugin(ColorSchemesPlugin)
      this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
    }
  }
</script>
